import { AppComponent } from './../app.component';
import { UsuarioFormulario } from './../domain/UsuarioFormulario';
import { Component, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';

import { MessageService } from 'primeng/components/common/messageservice';

import { Constantes } from '../domain/constantes';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { Permisos, PermisosService } from '../providers/authentication/permisos.service';
import { Predicate } from 'breeze-client';
import { TranslateService } from 'ng2-translate/src/translate.service';

@Component({
	selector: 'app-formulario-usuario',
	templateUrl: './FormularioUsuario.component.html',
	providers: [MessageService]
})

export class FormularioUsuarioComponent implements OnDestroy, OnChanges {

	@Input() usuarioSeleccionado: UsuarioFormulario;
	@Input() edicion: boolean;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	private isValid = false;
	public confirmacionVisible = false;
	public operacion = '';
	public cancelarGuardado = true;

	public perfiles = [];
	public perfilSeleccionado;
	public Contrasenia = '';
	public ReContrasenia = '';
	public constantesVar = Constantes;

	public usuarioActual: UsuarioFormulario;

	public errorMail =  false;
	public errorLoginVacio =  false;
	public errorPassword =  false;
	public errorRepetir =  false;
	public noComprobarPassword  = false;

	msgs: any[] = [];
	spinner: HTMLElement;
	public permisos: Permisos = new Permisos();


	constructor(
		private appComponent: AppComponent,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		private sws: ServiciosWebServiceProvider,
		private translate: TranslateService,
		private permisosService: PermisosService) {

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
		const that = this;
		this.entityManager.getPERFIL()
		.then(function(perfiles){
			that.perfiles = perfiles.filter( x => x.Tipo !== Constantes.CIUDADANO);
			const includes = 'ESPACIOS, PERFIL, PERFIL.FUNCIONALIDADES';

			const idEspacio = that.authService.getIdEspacio();
			// const predicado = new Predicate('IdEspacio', '==', idEspacio);
			const where = new Predicate('PERFIL.Tipo', '!=', Constantes.CIUDADANO);
			return entityManager.getUSUARIObyIdEspacio(idEspacio, includes, where);
		})
		.then(function(usuarios){

			const loginUsuarioActual = that.authService.getLastUser();
			const usu = new UsuarioFormulario(usuarios.filter( x => x.Login.toLowerCase()  === loginUsuarioActual.toLowerCase() )[0]);

			that.usuarioActual = usu;
			if (that.usuarioActual.Tipo === Constantes.ADMINISTRADOR_ENTIDAD) {
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.SUPER_ADMINISTRADOR);
			}

			if (that.usuarioActual.Tipo === Constantes.GESTOR_ESPACIOS) {
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.SUPER_ADMINISTRADOR);
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.ADMINISTRADOR_ENTIDAD);
			}

			if (that.usuarioActual.Tipo === Constantes.GESTOR_CONTENIDO) {
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.SUPER_ADMINISTRADOR);
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.ADMINISTRADOR_ENTIDAD);
				that.perfiles = that.perfiles.filter( x => x.Tipo !== Constantes.GESTOR_ESPACIOS);
			}

			that.errorMail =  false;
			that.errorLoginVacio =  false;
			that.errorPassword =  false;
			that.errorRepetir =  false;

			return true;
		})
		.then(function () {
			return that.comprobarPermisos();
		});
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.perfilSeleccionado = this.perfiles.filter( x => x.Tipo === this.usuarioSeleccionado.Tipo)[0];
		this.Contrasenia = '';
		this.ReContrasenia = '';
	}

	ngOnDestroy(): void {
		if (this.cancelarGuardado) {
			this.entityManager.RejectChanges();
		}
		this.Contrasenia = '';
		this.ReContrasenia = '';
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/*  */
	inputChanged(value) {
	}

	public validar(): boolean {
		this.msgs = [];

		this.noComprobarPassword = this.Contrasenia === '' && this.ReContrasenia === '';
		const emailExpresion = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		const error2 = this.Contrasenia.length < 8; // longitud Minima
		const error3 = !/\d/.test(this.Contrasenia); // contiene numeros
		const error4 = !/[A-Z]/.test(this.Contrasenia); // contiene mayusculas
		const error5 = !/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.Contrasenia); // contiene simbolo
		this.errorMail = !emailExpresion.test(String(this.usuarioSeleccionado.Email).toLowerCase()); // es email
		this.errorLoginVacio = this.usuarioSeleccionado.Login === ''; // Login Vacio
		this.errorRepetir = this.Contrasenia !==  this.ReContrasenia; // Repetir contraseña
		this.errorPassword = error2 || error3 || error4 || error5 || this.errorRepetir;

		const NolongitudMinima = this.translate.instant('Formularios.NolongitudMinima');
		const Nocontienenumeros = this.translate.instant('Formularios.Nocontienenumeros');
		const Nocontienemayusculas = this.translate.instant('Formularios.Nocontienemayusculas');
		const Nocontienesimbolo = this.translate.instant('Formularios.Nocontienesimbolo');
		const Noesemail = this.translate.instant('Formularios.Noesemail');
		const Nologin = this.translate.instant('Formularios.Nologin');
		const Nocoinciden = this.translate.instant('Formularios.Nocoinciden');



		if (this.noComprobarPassword) {

			if (this.errorMail || this.errorLoginVacio) {
				if (this.errorMail) {
					this.appComponent.showError(Noesemail);
				}
				if (this.errorLoginVacio) {
					this.appComponent.showError(Nologin);
				}
				this.isValid = false;
			}
			else{
				this.isValid = true;
			}

		}
		else {

			let mensajeError = '';
			this.isValid = true;
			if (error2) {
				mensajeError = mensajeError + NolongitudMinima;
				this.isValid = false;
			}
			if (error3) {
				mensajeError = mensajeError + Nocontienenumeros;
				this.isValid = false;
			}
			if (error4) {
				mensajeError = mensajeError + Nocontienemayusculas;
				this.isValid = false;
			}
			if (error5) {
				mensajeError = mensajeError + Nocontienesimbolo;
				this.isValid = false;
			}
			if (this.errorMail) {
				mensajeError = mensajeError + Noesemail;
				this.isValid = false;
			}
			if (this.errorLoginVacio) {
				mensajeError = mensajeError + Nologin;
				this.isValid = false;
			}
			if (this.errorRepetir) {
				mensajeError = mensajeError + Nocoinciden;
				this.isValid = false;
			}

			if (!this.isValid) {
				this.appComponent.showError(mensajeError);
			}
		}
		return this.isValid;
	}

	public guardar(): any {
		if (this.validar()) {

			this.spinner.style.display = 'inherit';

			if (this.edicion) {
				return this.guardarEdicion();
			}
			else{
				return this.guardarNuevo();
			}
		}

	}

	public guardarNuevo(){
		const that = this;
		this.cancelarGuardado = false;

		const idEspacio = that.authService.getIdEspacio();
		const Nombre = that.usuarioSeleccionado.Nombre;
		const Login = that.usuarioSeleccionado.Login;
		const Contrasenia = that.Contrasenia;
		const Email = that.usuarioSeleccionado.Email;

		if (that.perfilSeleccionado === undefined) {
			that.perfilSeleccionado = that.perfiles[0];
		}
		const idPerfil = that.perfilSeleccionado.Id;

		const token = this.authService.getToken();
		return 	that.authService.sws.wsCrearUsuario(token, Nombre, Login, Contrasenia, Email, idPerfil, idEspacio).toPromise()
		.then(function () {
			console.log('USUARIO Guardado CORRECTAMENTE');
			that.onElementoGuardado.emit(true);
			that.authService.relogin();
		})
		.catch(function (e) {
			that.onElementoError.emit(false);
		});
	}

	guardarEdicion(){

		const that = this;
		this.cancelarGuardado = false;

		const idEspacio = that.authService.getIdEspacio();
		const Nombre = that.usuarioSeleccionado.Nombre;
		const Login = that.usuarioSeleccionado.Login;
		const Contrasenia = this.Contrasenia;
		const Activo = that.usuarioSeleccionado.Activo;

		const Email = that.usuarioSeleccionado.Email;

		if (that.perfilSeleccionado === undefined) {
			that.perfilSeleccionado = that.perfiles[0];
		}
		const idPerfil = that.perfilSeleccionado.Id;

		const token = this.authService.getToken();

		// TODO: CAMBIAR PERFIL POR BREEZE Y LUEGO LLAMAR AL SERVICION WEB DE ACTUALIZAR USUARIO


		return 	that.authService.sws.wsUpdateUsuario(token, Nombre, Login, Contrasenia, Email, idPerfil, idEspacio, Activo).toPromise()
		.then(function () {
			console.log('USUARIO Guardado CORRECTAMENTE');
			that.onElementoGuardado.emit(true);
			that.authService.relogin();
		})
		.catch(function (e) {
			that.onElementoError.emit(false);
		});
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioUsuario.component.ts